// extracted by mini-css-extract-plugin
export default {"body":"InstructionsAlert_body__TIVPe","divider":"InstructionsAlert_divider__S1Kev","text":"InstructionsAlert_text__eQZtq"};